<div class="geolocation__city animated faster fadeIn" (click)="onChangeCity()" *ngIf="GeolocationValue">
  <div class="geolocation__city-icon">
    <span class="mr-icon mr-icon-city"></span>
  </div>
  <div class="geolocation__city-value">
    <p>{{GeolocationValue.name}}</p>
  </div>
</div>
